module.exports = __webpack_public_path__ + "static/media/anchor.e28d417b.jpg";